import { SearchByCnpjServiceInterface } from 'domain/services';
import { GetSearchByCnpjUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  searchByCnpj: GetSearchByCnpjUseCaseInterface;
}

export class SearchByCnpjService implements SearchByCnpjServiceInterface {
  private readonly _searchByCnpj: GetSearchByCnpjUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._searchByCnpj = usecases.searchByCnpj;
  }

  searchCnpj(
    params: GetSearchByCnpjUseCaseInterface.Params,
  ): Promise<GetSearchByCnpjUseCaseInterface.Result> {
    return this._searchByCnpj.execute(params);
  }
}
